module.exports = __webpack_public_path__ + "static/media/I_forgot_girl.9cf94dea.jpg";